import { useIntl } from '@capsicum/common';
import { BaseTextInput } from '@capsicum/common-web';
import React from 'react';
import styled from 'styled-components';

type EmailInputProps = {
	disabled?: boolean;
	emailError?: {
		message: string;
		type: string;
	};
	setUserEmail: (email: string) => Promise<void>;
	userEmail: string;
};

export const EmailInput = ({ disabled, emailError, setUserEmail, userEmail }: EmailInputProps) => {
	const { $t } = useIntl();

	const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setUserEmail(event.target.value);
	};

	return (
		<S.Container>
			<S.Title>{$t('jurisdictionRequirements.emailVerification.yourEmailAddress')}</S.Title>
			<BaseTextInput
				autoCapitalize="none"
				disabled={disabled}
				error={emailError}
				label={$t('jurisdictionRequirements.emailVerification.emailAddress')}
				testID="email-verification-input"
				value={userEmail}
				onChange={handleEmailChange}
			/>
		</S.Container>
	);
};

namespace S {
	export const Container = styled.div`
		display: flex;
		flex-direction: column;
	`;

	export const Title = styled.span`
		color: ${({ theme }) => theme.colors.text.main.enabled};
		${({ theme }) => theme.fonts.headings.title5};
		margin-bottom: ${({ theme }) => theme.sizing.xsmall};
	`;
}
